export default __webpack_public_path__ + "img/pin_icons/radioactive_b.svg";